import React from 'react';
import '../less';
import Emojify from 'react-emojione';
import { LANG } from "../../../services/l10n";
import { Link} from 'MWC';
import Preloader from "MWComponents/dest/components/Preloader";
import Tooltip from "../../../auxiliary-components/shared/Tooltip";

export default function template() {
    const isMobile = this.isViewportMobile(),
        vacanciesList = '/career/vacancies-list',
        isUa = this.props.lang === LANG.UA;
    const filters = this.props.state.departments.map(elem => {
      const text = isUa ? elem.name_ua : elem.name_ru;
      return (<button title={text} key={elem.id} value={elem.id}
                      onClick={(e) => {
                                  this.changeFilter(e);
                                  this.context.app.navigate('career/vacancies-list', e);
                                }}
                      name="department" className="vacancies-list-filters-wrap-filter">
               {text}
              </button>)
    }),
      tooltip = this.state.showTooltip ?  <Tooltip display={this.state.showTooltip ? 'flex' : 'none'} element={this.state.tooltipElement} >{this.state.tooltipText}</Tooltip> : '',
      positions = this.state.preload ?
        (<div className="preload-wrapper">
          <Preloader />
        </div>)
        :
        this.state.vacancies.map(elem => {
          const name = isUa ? elem.name_ua : elem.name_ru;
          const tag = isUa ? elem.department?.name_ua : elem.department?.name_ru;
          return <div key={elem.id} className="vacancies-list-positions-wrap-item">
                    <div>
                      <h3 className="vacancies-list-positions-wrap-item-title"
                           onPointerEnter={(event) => this.setTooltipState(event, true, name)}
                           onPointerLeave={(event) => this.setTooltipState(event, false)}>
                        {name}
                      </h3>
                      <div className="vacancies-list-positions-wrap-item-desc">
                        {tag}
                      </div>
                    </div>
                    <div
                        className="vacancies-list-positions-wrap-more"
                        onClick={(e) => this.context.app.navigate(`career/vacancies-list/${elem.id}`, e)}
                        >{this.l10n('CAREER_VACANCIES_DETAILS')}</div>
                </div>
      });
    return (
        <div className="module-career-container">
            <div className="side-a slider-wrapper">
                <div className='slide slider-main slide-career'>
                    <div className='slide-content'>
                        <div className='green-content'>
                            <h1 className='slider-main-head' dangerouslySetInnerHTML={{ __html: this.l10n('CAREER_BANNER_TITLE')}}>
                            </h1>
                            <div className='slider-desc'
                                 dangerouslySetInnerHTML={{ __html: !isMobile ? this.l10n('CAREER_BANNER_DESC') : this.l10n('CAREER_BANNER_DESC')}}>
                            </div>
                            <div className='slider-info'>
                                <Link href={vacanciesList} target="_self">
                                    <button className='btn btn-transparent'>
                                        {this.l10n('CAREER_VACANCIES_TITLE')}
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="module-content-wrapper vacancies-list">
                <h2 className="block-title">{this.l10n('CAREER_VACANCIES_TITLE')}</h2>
                <div className="vacancies-list-filters-wrap">
                  <button title={this.l10n('CAREER_HOT')}
                          onClick={(e) => {
                            this.changeFilter(e);
                            this.context.app.navigate('career/vacancies-list', e);
                          }}
                          name="hot"
                          value="true"
                          className="vacancies-list-filters-wrap-filter"
                  >
                    {this.l10n('CAREER_HOT')}
                  </button>
                  {filters}
                  <div className="vacancies-list-filters-wrap-more"
                          onClick={(e) => {
                            this.model.resetParams();
                            this.context.app.navigate("career/vacancies-list", e);
                          }}>
                    {this.l10n('CAREER_VACANCIES_FILTERS_ALL')}
                  </div>
                </div>
                <div className="vacancies-list-positions-wrap">
                  {positions}
                  {tooltip}
                </div>
                <button className="vacancies-list-btn"
                        onClick={(e) => {
                          this.model.resetParams();
                          this.context.app.navigate("career/vacancies-list", e);
                        }}>
                  {this.l10n('CAREER_VACANCIES_MORE')}
                </button>
            </div>

            <div className="module-content-wrapper email-banner">
              <div className="email-banner-left">
                <div className="email-banner-left-text" dangerouslySetInnerHTML={{__html: this.l10n('CAREER_EMAIL_BANNER_TEXT')}}>
                </div>
                <a href="mailto:hr@a-bank.com.ua" className="email-banner-left-desc">
                  {this.l10n('CAREER_EMAIL_BANNER_DESC')}
                </a>
             </div>
            </div>

            <div className="module-content-wrapper abank-values">
              <h2 className="block-title">{this.l10n('CAREER_ABANK_VALUES_TITLE')}</h2>
              <div className="abank-values-wrapper">
                <div className="abank-values-wrapper-item">
                  <h3 className="abank-values-wrapper-item-title">
                    <Emojify>
                      <span>🤵</span>
                    </Emojify>
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_1_TITLE')}
                  </h3>
                  <div className="abank-values-wrapper-item-text">
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_1_TEXT')}
                  </div>
                </div>
                <div className="abank-values-wrapper-item">
                  <h3 className="abank-values-wrapper-item-title">
                    <Emojify>
                      <span>👨🏻‍💻</span>
                    </Emojify>
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_2_TITLE')}
                  </h3>
                  <div className="abank-values-wrapper-item-text">
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_2_TEXT')}
                  </div>
                </div>
                <div className="abank-values-wrapper-item">
                  <h3 className="abank-values-wrapper-item-title">
                    <Emojify>
                      <span>⚙️</span>
                    </Emojify>
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_3_TITLE')}
                  </h3>
                  <div className="abank-values-wrapper-item-text">
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_3_TEXT')}
                  </div>
                </div>
                <div className="abank-values-wrapper-item">
                  <h3 className="abank-values-wrapper-item-title">
                    <Emojify>
                      <span>🌟</span>
                    </Emojify>
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_4_TITLE')}
                  </h3>
                  <div className="abank-values-wrapper-item-text">
                    {this.l10n('CAREER_ABANK_VALUES_ITEM_4_TEXT')}
                  </div>
                </div>
              </div>
            </div>

          <div className="module-content-wrapper advantages">
            <h2 className="block-title">{this.l10n('CAREER_ADVANTAGES_TITLE')}</h2>
            <div className="advantages-list">
              <div className="advantages-list-wrap">
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_1')}
                </div>
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_2')}
                </div>
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_3')}
                </div>
              </div>
              <div className="advantages-list-wrap">
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_4')}
                </div>
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_5')}
                </div>
                <div className="advantages-list-wrap-item">
                  {this.l10n('CAREER_ADVANTAGES_ITEM_6')}
                </div>
              </div>
            </div>
            <div className="advantages-banner">
                <div className="advantages-banner-text" dangerouslySetInnerHTML={{__html: this.l10n('CAREER_ADVANTAGES_BANNER_TEXT')}}>
                </div>
                <div className="advantages-banner-desc">
                  {this.l10n('CAREER_ADVANTAGES_BANNER_DESC')}
                </div>
            </div>
          </div>
          <div className="module-content-wrapper contacts">
            <h2 className="block-title">{this.l10n('CAREER_CONTACTS_TITLE')}</h2>
            <div className="contacts-list">
              <div className="contacts-list-item">
                <div className="contacts-list-item-title">{this.l10n('CAREER_ITEM_1_TEXT')}</div>
                <div className="contacts-list-item-text">{this.l10n('CAREER_ITEM_1_DESC')}</div>
              </div>
              <div className="contacts-list-item">
                <div className="contacts-list-item-title">{this.l10n('CAREER_ITEM_2_TEXT')}</div>
                <div className="contacts-list-item-text">{this.l10n('CAREER_ITEM_2_DESC')}</div>
              </div>
            </div>
            <div className="contacts-social-list">
              <a href="https://www.facebook.com/robotaabank" target="_blank" className="contacts-social-list-item facebook"></a>
              <a href="https://www.instagram.com/robotaabank/" target="_blank" className="contacts-social-list-item insta"></a>
              <a href="https://www.linkedin.com/company/53436649/admin/" target="_blank" className="contacts-social-list-item linkedIn"></a>
              <a href="https://www.tiktok.com/@abank_official" target="_blank" className="contacts-social-list-item tiktok"></a>
              <a href="https://www.youtube.com/channel/UC5UByAW-8_zgjZoAu8LbvRQ?view_as=subscriber" target="_blank" className="contacts-social-list-item youtube"></a>
            </div>
          </div>
        </div>
    );
}
